"use strict";

// commonmark.js - CommomMark in JavaScript
// Copyright (C) 2014 John MacFarlane
// License: BSD3.

// Basic usage:
//
// var commonmark = require('commonmark');
// var parser = new commonmark.Parser();
// var renderer = new commonmark.HtmlRenderer();
// console.log(renderer.render(parser.parse('Hello *world*')));

module.exports.version = '0.27.0';
module.exports.Node = require('./node');
module.exports.Parser = require('./blocks');
// module.exports.HtmlRenderer = require('./html');
module.exports.HtmlRenderer = require('./render/html');
module.exports.XmlRenderer = require('./xml');



//////////////////
// WEBPACK FOOTER
// ./~/commonmark/lib/index.js
// module id = 784
// module chunks = 1